import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import { RequestStatusEnum } from '@shared/types';

interface EmptyListProps extends BoxProps {
    getListStatus: RequestStatusEnum;
    count: number;
    isFilteringApplied: boolean;
    handleClearAllFilters: () => void;
    handleOpenAddModal?: () => void;
    objectsForTranslationLabel: string;
    addObjectLabel?: string;
    favoritesMode?: boolean;
}

const EmptyList: FC<EmptyListProps> = ({
    getListStatus,
    count,
    isFilteringApplied,
    handleClearAllFilters,
    handleOpenAddModal,
    objectsForTranslationLabel,
    addObjectLabel,
    favoritesMode,
    ...props
}) => {
    const { t } = useTranslation();

    return (getListStatus === RequestStatusEnum.Success || getListStatus === RequestStatusEnum.Error) && !count ? (
        <Box
            sx={{
                p: 2,
            }}
            {...props}
        >
            <Typography component="span">
                {isFilteringApplied ? (
                    `${t('no_results_for_filters')} `
                ) : favoritesMode ? (
                    <Typography
                        component={'span'}
                        sx={{
                            color: 'var(--text-secondary)',
                            fontStyle: 'italic',
                        }}
                    >
                        {t('no_record_to_display')}...
                    </Typography>
                ) : (
                    `${t('no_objects_added_yet', { objects: objectsForTranslationLabel })} `
                )}
            </Typography>
            <Typography
                sx={{ cursor: 'pointer' }}
                component="span"
                onClick={isFilteringApplied ? handleClearAllFilters : handleOpenAddModal}
                color="primary"
            >
                {isFilteringApplied ? t('clear_all_filters') : !favoritesMode && addObjectLabel}
            </Typography>
        </Box>
    ) : (
        <></>
    );
};

export default EmptyList;
